<!-- Custom Dialog Layout with Fixed Header -->
<div class="order-dialog-container">
  <!-- Fixed Header with Title -->
  <div class="fixed-header">
    <!-- Dialog Title Section -->
    <div class="dialog-title-section">
      <div class="flex justify-between items-start">
        <div>
          <h1 class="text-xl font-medium text-on-surface">Order Details</h1>
          <p class="text-sm mt-2 text-on-surface-variant">View and manage your order items</p>
        </div>
        <button
          type="button"
          class="close-button"
          (click)="closeDialog()"
          aria-label="Close dialog"
        >
          <mat-icon svgIcon="close" class="w-6 h-6"></mat-icon>
        </button>
      </div>
    </div>

    <!-- Tab Navigation -->
    <div>
      <div class="flex space-x-1 border-b border-outline-variant">
        <button
          class="px-4 py-2 text-sm font-medium transition-colors duration-200"
          [class]="selectedTabIndex === 0 ? 'text-primary border-b-2 border-primary' : 'text-on-surface-variant hover:text-on-surface'"
          (click)="selectTab(0)"
        >
          Order Information
        </button>
        <button
          class="px-4 py-2 text-sm font-medium transition-colors duration-200"
          [class]="selectedTabIndex === 1 ? 'text-primary border-b-2 border-primary' : 'text-on-surface-variant hover:text-on-surface'"
          (click)="selectTab(1)"
        >
          Order Items
        </button>
      </div>
    </div>
  </div>

  <!-- Scrollable Content Area -->
  <div class="flex-1 overflow-y-auto">
    <div class="px-11 py-6">
      <!-- Tab Content -->
      @if (orderDetail$ | async; as order) {
        <!-- Order Information Tab Content -->
        @if (selectedTabIndex === 0) {
          <div class="space-y-6">
            <!-- Order Header Section -->
            <div class="order-summary-section p-4">
              <h3 class="text-lg font-semibold mb-4 text-on-surface">Order Header</h3>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label class="block text-sm font-medium text-on-surface-variant">Order ID</label>
                  <p class="mt-1 text-sm text-on-surface font-semibold">#{{ order.id }}</p>
                </div>
                <div>
                  <label class="block text-sm font-medium text-on-surface-variant">Order Date</label>
                  <p class="mt-1 text-sm text-on-surface">{{ order.orderDate | date:'yyyy/MM/dd HH:mm' }}</p>
                </div>
                <div>
                  <label class="block text-sm font-medium text-on-surface-variant">Your Total Amount</label>
                  <p class="mt-1 text-sm text-on-surface font-semibold">{{ order.prices?.totalOrderPrice | kwdCurrency }}</p>
                </div>
              </div>

              <!-- Status Display (Read-only for vendors) -->
              <div class="mt-4">
                <div>
                  <label class="block text-sm font-medium text-on-surface-variant">Order Status</label>
                  <p class="mt-1 text-sm text-on-surface font-medium">{{ getStatusDisplayName(order.status) }}</p>
                </div>
              </div>

              <!-- Order Note Display -->
              @if (order.orderNote) {
                <div class="mt-4">
                  <div>
                    <label class="block text-sm font-medium text-on-surface-variant">Order Note</label>
                    <p class="mt-1 text-sm text-on-surface bg-surface-variant/20 p-3 rounded-md border border-outline-variant">{{ order.orderNote }}</p>
                  </div>
                </div>
              }
            </div>

            <!-- Vendor Pricing Information -->
            <div class="order-summary-section p-4">
              <h3 class="text-lg font-semibold mb-4 text-on-surface">Your Order Totals</h3>

              <!-- Vendor Pricing Breakdown -->
              <div class="border-t border-outline-variant pt-4">
                <h4 class="text-base font-medium mb-3 text-on-surface">Your Items Pricing</h4>
                @if (order.prices) {
                  <div class="space-y-3">
                    <div class="flex justify-between">
                      <span class="text-sm text-muted">Your Items Price:</span>
                      <span class="text-sm font-medium text-on-surface">{{ order.prices.itemsPrice | kwdCurrency }}</span>
                    </div>

                    @if (order.prices.itemsDiscount && order.prices.itemsDiscount > 0) {
                      <div class="flex justify-between text-success">
                        <span class="text-sm">Your Items Discount:</span>
                        <span class="text-sm font-medium">-{{ order.prices.itemsDiscount | kwdCurrency }}</span>
                      </div>
                    }

                    @if (order.prices.totalCouponCodeDiscount && order.prices.totalCouponCodeDiscount > 0) {
                      <div class="flex justify-between text-success">
                        <span class="text-sm">Coupon Discount (Your Items):</span>
                        <span class="text-sm font-medium">-{{ order.prices.totalCouponCodeDiscount | kwdCurrency }}</span>
                      </div>
                    }

                    <hr class="border-outline-variant">

                    <div class="flex justify-between text-lg font-semibold text-on-surface">
                      <span>Your Total Amount:</span>
                      <span>{{ order.prices.totalOrderPrice | kwdCurrency }}</span>
                    </div>
                  </div>
                } @else {
                  <p class="text-sm text-muted">Pricing information not available</p>
                }
              </div>
            </div>
          </div>
        }

        <!-- Order Items Tab Content -->
        @if (selectedTabIndex === 1) {
          <div class="space-y-4">
            <cac-table [options]="orderItemsTable"></cac-table>
          </div>
        }
      }
    </div>
  </div>

  <!-- Fixed Footer with Actions -->
  <div class="fixed-footer">
    <div class="flex justify-between items-center">
      <!-- Mark All as Ready Button (visible only on Order Items tab) -->
      @if (selectedTabIndex === 1) {
        <cac-button
          theme="primary"
          (onClick)="markOrderAsReady()"
          [disabled]="loading">
          Mark Order as Ready
        </cac-button>
      } @else {
        <div></div>
      }

      <!-- Close Button -->
      <cac-button theme="secondary" (onClick)="closeDialog()">
        Close
      </cac-button>
    </div>
  </div>
</div>
